import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateNumberComponent } from "../../templates/template-number/template-number.component";
import { Max } from "../../types/Max";
import { Min } from "../../types/Min";

@Component({
  selector: "app-prefix-bce",
  imports: [TemplateNumberComponent],
  templateUrl: "./prefix-bce.component.html",
  styleUrl: "./prefix-bce.component.less",
})
export class PrefixBceComponent extends PrefixComponent<string> {
  public max: Max;
  public min: Min;
  public commas: number;

  public constructor() {
    super({ updateOn: "blur" });
    this.commas = 0;
    this.min = 0;
    this.max = 99999999;
    this.required = false;
    this.characters = ALLOWED_CHARACTERS["bce"];
  }
}
